export default __webpack_public_path__ + "static/media/Jarno-cor.e5d18e3b.png";